var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
const u = up.util;
up.Change.FromResponse = (_a = class FromResponse extends up.Change {
        constructor(options) {
            super(options);
            this._response = options.response;
            this._request = this._response.request;
        }
        execute() {
            var _b;
            if (up.fragment.config.skipResponse(this._loadedEventProps())) {
                this._skip();
            }
            else {
                this._request.assertEmitted('up:fragment:loaded', Object.assign(Object.assign({}, this._loadedEventProps()), { callback: this.options.onLoaded, log: ['Loaded fragment from %s', this._response.description], skip: () => this._skip() }));
                this._assetRenderableResponse();
            }
            let fail = (_b = u.evalOption(this.options.fail, this._response)) !== null && _b !== void 0 ? _b : !this._response.ok;
            if (fail) {
                throw this._updateContentFromResponse(this.deriveFailOptions());
            }
            return this._updateContentFromResponse(this.options);
        }
        _assetRenderableResponse() {
            if (!up.fragment.config.renderableResponse(this._response)) {
                throw new up.CannotParse(['Cannot render response with content-type "%s" (configure with up.fragment.config.renderableResponse)', this._response.contentType]);
            }
        }
        _skip() {
            up.puts('up.render()', 'Skipping ' + this._response.description);
            this.options.target = ':none';
            this.options.failTarget = ':none';
        }
        _updateContentFromResponse(finalRenderOptions) {
            if (finalRenderOptions.didForceFailOptions) {
                up.puts('up.render()', 'Rendering failed response using fail-prefixed options (https://unpoly.com/failed-responses)');
            }
            this._augmentOptionsFromResponse(finalRenderOptions);
            finalRenderOptions.meta = this._helloMeta();
            finalRenderOptions.verifyFinished = (result) => this._revalidate(result, finalRenderOptions);
            return new up.Change.FromContent(finalRenderOptions).execute();
        }
        _revalidate(renderResult, originalRenderOptions) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!up.fragment.shouldRevalidate(this._request, this._response, originalRenderOptions))
                    return;
                let inputTarget = originalRenderOptions.target;
                let effectiveTarget = renderResult.target;
                if (/:(before|after)/.test(inputTarget)) {
                    up.warn('up.render()', 'Cannot revalidate cache when prepending/appending (target %s)', inputTarget);
                }
                else {
                    up.puts('up.render()', 'Revalidating cached response for target "%s"', effectiveTarget);
                    let revalidateResult = yield up.reload(effectiveTarget, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, originalRenderOptions), up.RenderOptions.NO_MOTION), up.RenderOptions.NO_INPUT_INTERFERENCE), up.RenderOptions.NO_PREVIEWS), { feedback: originalRenderOptions.feedback, preferOldElements: renderResult.fragments, layer: renderResult.layer, onFinished: null, expiredResponse: this._response, preview: this._revalidatePreview(originalRenderOptions), abort: false, cache: false, background: true }));
                    if (!revalidateResult.none) {
                        return revalidateResult;
                    }
                }
            });
        }
        _revalidatePreview({ preview, revalidatePreview }) {
            if (revalidatePreview === true) {
                return preview;
            }
            else {
                return revalidatePreview;
            }
        }
        _loadedEventProps() {
            const { expiredResponse } = this.options;
            return {
                request: this._request,
                response: this._response,
                renderOptions: this.options,
                revalidating: !!expiredResponse,
                expiredResponse,
            };
        }
        _helloMeta() {
            var _b, _c;
            let meta = { revalidating: !!this.options.expiredResponse, ok: this._response.ok };
            (_c = (_b = up.migrate).processHelloMeta) === null || _c === void 0 ? void 0 : _c.call(_b, meta, this._response);
            return meta;
        }
        _augmentOptionsFromResponse(renderOptions) {
            var _b, _c;
            const responseURL = this._response.url;
            let serverLocation = responseURL;
            let hash = this._request.hash;
            if (hash) {
                renderOptions.hash = hash;
                serverLocation += hash;
            }
            const isReloadable = (this._response.method === 'GET');
            if (isReloadable) {
                renderOptions.source = up.history.refineOption(renderOptions.source, responseURL);
            }
            else {
                renderOptions.source = up.history.refineOption(renderOptions.source, 'keep');
                renderOptions.history = !!renderOptions.location;
            }
            let openLayerOptions = this._response.openLayer;
            if (openLayerOptions) {
                up.script.adoptRenderOptionsFromHeader(openLayerOptions, this._response.cspInfo);
                Object.assign(renderOptions, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, up.Layer.Overlay.UNSET_VISUALS), { target: undefined }), up.fragment.config.navigateOptions), openLayerOptions), { layer: 'new' }));
            }
            renderOptions.location = up.history.refineOption(renderOptions.location, serverLocation);
            renderOptions.title = up.history.refineOption(renderOptions.title, this._response.title);
            renderOptions.eventPlans = this._response.eventPlans;
            let serverTarget = this._response.target;
            if (serverTarget) {
                renderOptions.target = serverTarget;
            }
            renderOptions.acceptLayer = this._response.acceptLayer;
            renderOptions.dismissLayer = this._response.dismissLayer;
            renderOptions.document = this._response.text;
            if (this._response.none) {
                renderOptions.target = ':none';
            }
            renderOptions.context = u.merge(renderOptions.context, this._response.context);
            renderOptions.cspInfo = this._response.cspInfo;
            (_b = renderOptions.time) !== null && _b !== void 0 ? _b : (renderOptions.time = this._response.lastModified);
            (_c = renderOptions.etag) !== null && _c !== void 0 ? _c : (renderOptions.etag = this._response.etag);
        }
    },
    (() => {
        u.memoizeMethod(_a.prototype, {
            _loadedEventProps: true,
        });
    })(),
    _a);
